const columns = [
  {
    name: 'Team',
    selector: (row) => row.attributes.title,
    sortable: true,
    searchable: true,
  },
  {
    name: 'Number of Members',
    selector: (row) => row.attributes.team_size,
  },
];

export default columns;
